/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalStyle } from 'assets/styles/global-styles';
import { useTranslation } from 'react-i18next';

import PrivateRoutes from 'utils/privateRoute';
import { getUserToken } from 'lib/storage';

import NavBar from './components/NavBar';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { Authentication } from './pages/auth/Loadable';
import { AttributeList } from './pages/AttributeList/Loadable';
import SideBar from './components/SideBar';
import { AttributeGroup } from './pages/AttributeGroup/Loadable';
import { AttributeValue } from './pages/AttributeValue/Loadable';
import { AttributeRule } from './pages/AttributeRule/Loadable';

export function App() {
  const { i18n } = useTranslation();

  const [theme, setTheme] = React.useState(localStorage.getItem('theme') || 'light');
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };
  React.useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme]);

  return (
    <BrowserRouter>
      <Helmet
        titleTemplate="Adeptmind Attribute Extraction Tool"
        defaultTitle="Adeptmind Attribute Extraction Tool"
        htmlAttributes={{ lang: i18n.language }}
      />

      <div>
        <NavBar toggleNightMode={toggleTheme} theme={theme} />
        <SideBar theme={theme} />
        <Routes>
          <Route
            path="/"
            element={getUserToken() === null ? <Authentication theme={theme} /> : <AttributeList theme={theme} />}
          />
          {getUserToken() !== null && (
            <Route element={<PrivateRoutes />}>
              <Route path="/:attribute_name" element={<AttributeGroup theme={theme} />} />
              <Route path="/:attribute_name/:attribute_value" element={<AttributeValue theme={theme} />} />
              <Route path="/:attribute_name/:attribute_value/:rule_id" element={<AttributeRule theme={theme} />} />
            </Route>
          )}

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <GlobalStyle />
      </div>
    </BrowserRouter>
  );
}
